import {Component, Inject, Injector, Input, OnInit, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import {UpaTarget, UpaTrackingData} from '../../services/upa.service';
import { BackgroundData } from '../background/background.component';
import { MainTitle } from '../main-title/main-title.component';
import { HeaderData, HeaderModule, ProductMainTitle } from './common-header.component';
import {MapModuleModel} from "../map-module/map-module.model";
import {Module} from "../../model/ModuleModel";
import { isPlatformBrowser } from '@angular/common';
import { AbstractComponent } from '../abstract.component';

declare var window: any;

@Component({
  selector: 'header-wrapper',
  template: `
    <header-view-1 *ngIf="!module?.data?.view_type || module.data.view_type === 'VIEW_1'"
      [sboxModule]="sboxModule" [backgroundModule]="backgroundModule"
      [mainTitleModule]="mainTitleModule" [titleInNavBar]="titleInNavBar" [openLinkInNewTab]="module.data.open_link_in_new_tab"
      [module]="module" [upaTrackingData]="upaTrackingData" [product]="product" [flow]="flow" [shifuProduct]="shifuProduct"></header-view-1>

    <header-view-2 *ngIf="module?.data?.view_type === 'VIEW_2'"
      [sboxModule]="sboxModule" [backgroundModule]="backgroundModule"
      [mainTitleModule]="mainTitleModule" [productMainTitleModule]="productMainTitleModule" [titleInNavBar]="titleInNavBar"
      [module]="module" [mapModule]="mapModule" [product]="product" [flow]="flow" [upaTrackingData]="upaTrackingData" [shifuProduct]="shifuProduct"></header-view-2>

    <header-view-3 *ngIf="module.data.view_type === 'VIEW_3'"
      [sboxModule]="sboxModule" [backgroundModule]="backgroundModule"
      [mainTitleModule]="mainTitleModule" [titleInNavBar]="titleInNavBar"
      [module]="module" [product]="product" [flow]="flow" [shifuProduct]="shifuProduct"></header-view-3>

    <heading-app *ngIf="module.data.view_type === 'HEADING_APP'" [module]="module" [titleInNavBar]="titleInNavBar"></heading-app>

    <heading-video *ngIf="module?.data?.view_type === 'HEADING_VIDEO'" [module]="module" [titleInNavBar]="titleInNavBar"></heading-video>
  `,
  styleUrls: ['./header-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderWrapperComponent extends AbstractComponent implements OnInit {
  static MODULE_ID = 'HeadingModule';

  @Input() backgroundModule?: { data: BackgroundData };
  @Input() sboxModule: any;
  @Input() mainTitleModule: { data: MainTitle };
  @Input() productMainTitleModule?: { data: ProductMainTitle };
  @Input() override module: HeaderModule<HeaderData>;
  @Input() mapModule?: Module<MapModuleModel>;

  @Input() override product: string;
  @Input() override flow: string;

  @Input() shifuProduct: string;

  upaTrackingData: UpaTrackingData;
  titleInNavBar: boolean = false;

  constructor(injector: Injector, @Inject(PLATFORM_ID) public platformId: string) {
    super(injector);
  }

  ngOnInit() {
    this.upaTrackingData = this.getUpaTrackingData();
    const mainTitle: MainTitle = this.mainTitleModule?.data || this.module.data?.main_title;
    this.titleInNavBar = this.shouldShowTitleInNavBar(mainTitle);

    if (this.titleInNavBar && isPlatformBrowser(this.platformId)) {
      var event = new CustomEvent('app.navbar', {
        detail: {
            main_view: {
                title: mainTitle.title?.text,
                ...(mainTitle.sub_title && { subtitle: [
                      {
                          text: mainTitle.sub_title.text
                      }
                  ]
                })
            },
            product: this.product,
            flow: this.flow,
            pageview_id: window.upaData.pageview_id,
        }
      });
      document.dispatchEvent(event);
    }
  }

  getUpaTrackingData(): UpaTrackingData {
    const { title, pre_title, sub_title } = this.mainTitleModule?.data || this.module.data?.product_main_title || {};
    const label = title?.text || pre_title?.text || sub_title?.text || 'no-label';
    return {
      label,
      moduleId: HeaderWrapperComponent.MODULE_ID,
      moduleIndex: this.module.position,
      target: UpaTarget.HEADING,
      href: this.module.data.link || this.module.data.scroll_target,
      uniqueId: this.module.unique_id
    };
  }

  shouldShowTitleInNavBar(mainTitle: MainTitle): boolean {
    const landingModel = this.landingModelService.getLandingModel();
    const appNavbarCookie = landingModel.headers?.["cookies"]["xdesp-appnavbar"]

    return !!mainTitle?.title_in_nav_bar
          && landingModel.webview
          && appNavbarCookie?.includes("title")
  }

  getModuleId(): string {
    return HeaderWrapperComponent.MODULE_ID;
  }
}
